import { Component, OnInit, Input } from '@angular/core';
import { Compra } from '../../../models/compra';
import { CompraService } from '../../../services/compra.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { TipoDocumento } from '../../../models/tipo-documento';
import { ProductoService } from '../../../services/producto.service';
import { SessionService } from '../../../services/session.service';
import { SerieService } from '../../../services/serie.service';
import { Serie } from '../../../models/serie';
import { SerieDetalleModalComponent } from '../serie-detalle-modal/serie-detalle-modal.component';
import { BsModalService } from 'ngx-bootstrap';

@Component({
	selector: 'compra-modal',
	templateUrl: './compra-modal.component.html',
    styleUrls: ['./compra-modal.component.css'],
    providers: [CompraService, ProductoService, SerieService]
})
export class CompraModalComponent implements OnInit {
    @Input() compra_id: String;
    @Input() numero_decimales: number = 2;
    public compra: Compra;
    public tipoDoc:TipoDocumento;
    public loading = false;
    public format_decimal: String;
    public Mod_Cartera: string;
    public bsModalRef2: BsModalRef;
	constructor(
        private compraService: CompraService,
        private productoService: ProductoService,
        private serieService: SerieService,
        public bsModalRef: BsModalRef,
        private modalService: BsModalService,
        private ss: SessionService,
    ) {
        this.compra = new Compra();
        this.format_decimal = "0,0.00";
        this.tipoDoc = new TipoDocumento();
        this.Mod_Cartera = this.ss.getData("mod_cartera");
    }

	ngOnInit() {
        let digitos = "";
		for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
        this.format_decimal = "0,0." + digitos
        
        this.getCompraById();
    }

    getCodigoSerie(codigo = ''){
        return codigo + ', ';
    }
    
    getCompraById(){
        this.loading = true;
        let qs = '?embed=bodega,proveedor,detalle?embed=producto,tipocomprobante,detalle?embed=series?embed=serie';

        if (this.tipoDoc.id) {
            qs += "&tipo_comprobante_id =" + this.tipoDoc.id;
        }

        this.compraService.getById(this.compra_id, qs).subscribe(
            res => {

                
                this.compra = res.data;
                let qs = '?embed=unidadmedida';
                this.compra.detalle.forEach(d=>{
                    this.productoService.getById(d.id, qs).subscribe(
                        res => {
                            d.producto.unidadmedida = res.unidadmedida;
                            this.loading = false;
                        },
                        err => {
                            this.loading = false;
                        }
                    );
                    d.series.forEach( s => {
                        this.serieService.getById(s.serie_id).subscribe(
                            res => {
                               s.serie = res.data;
                                this.loading = false;
                            },
                            err => {
                                this.loading = false;
                            }
                        );
                    })    
                   
                });
                
            },
            err => {
                this.loading = false;
            }
        );
    }

    getNumeroDocumento(compra){
		return compra.serie + "-" + compra.punto_emision + "-" + compra.secuencial;
    }
    
    get formatDecimal(){
        return this.format_decimal;
    }

    parseTipo(tipo){
		if( tipo === "CR" ){
			return "Crédito";
		}else{
			return "Contado";
		}
    }

    openModalSerie(series: Array<Serie>) {
		const initialState = { series: series,numero_decimales: this.numero_decimales };
		this.bsModalRef2 = this.modalService.show(SerieDetalleModalComponent, Object.assign({backdrop: 'static',initialState }));

		
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/compra-modal/compra-modal.component.ts